import { getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'beneficiaries') {
    return;
  }

  const $hasDeclaredBeneficiaries = $('#hasDeclaredBeneficiaries input[type=radio]', $form);

  $hasDeclaredBeneficiaries.on('click', (inputElement) => {
    if(inputElement.target.value === 'true') {
      $('#beneficiariesTable').addClass('d-none');
    } else {
      $('#beneficiariesTable').removeClass('d-none');
    }
  });
})
